import './index.css';

export const WAITLIST_STATUS_OPTIONS = [
	{ value: 'green', label: 'Accepting Enquiries', indicator: 'Accepting enquiries — no wait list' },
	{ value: 'amber', label: 'Wait list', indicator: 'Wait list — accepting tour bookings' },
	{ value: 'red', label: 'Closed', indicator: 'Wait list — not accepting tour bookings' },
];

export default function TrafficLightToggle({ name, legend, value = 'green', onChange, options = WAITLIST_STATUS_OPTIONS, disabled = false }) {
	const activeIndex = options.findIndex((option) => option.value === value);
	const active = activeIndex >= 0 ? options[activeIndex] : null;

	return (
		<fieldset className="traffic-light-toggle" disabled={disabled}>
			{legend && <legend className="traffic-light-toggle__legend">{legend}</legend>}
			<div className="traffic-light-toggle__track" style={{ '--tlt-count': options.length, '--tlt-index': Math.max(activeIndex, 0) }}>
				{active && <span className={`traffic-light-toggle__thumb traffic-light-toggle__thumb--${active.value}`} aria-hidden="true" />}
				{options.map((option) => (
					<label
						key={option.value}
						className={`traffic-light-toggle__option ${value === option.value ? 'is-active' : ''}`}
					>
						<input
							className="traffic-light-toggle__input"
							type="radio"
							name={name}
							value={option.value}
							checked={value === option.value}
							onChange={() => onChange?.(option.value)}
						/>
						<span className={`traffic-light-toggle__dot traffic-light-toggle__dot--${option.value}`} aria-hidden="true" />
						<span className="traffic-light-toggle__label">{option.label}</span>
					</label>
				))}
			</div>
			<p className="traffic-light-toggle__indicator" aria-live="polite">{active?.indicator ?? 'No status selected'}</p>
		</fieldset>
	);
}
